export default () => ({
  errors: {},
  loading: true,
  onCancel: false,
  fullPage: true,
  statistics: []
})



// WEBPACK FOOTER //
// ./src/app/dweller/dashboard/gadget/resources/data.js